import { AgentConfig } from '../types/agent.types';

/**
 * Find an agent by name or ID (case-insensitive).
 */
export function findAgentByNameOrId(
  agents: AgentConfig[],
  query: string,
): AgentConfig | undefined {
  const normalised = query.toLowerCase();
  return agents.find(
    (a) =>
      a.id.toLowerCase() === normalised ||
      a.name.toLowerCase() === normalised,
  );
}
